import { useCallback, useEffect, useState } from "react";
import { fetchMaintenanceConfig } from "services/maintenance/maintenanceConfig";

const MAINTENANCE_POLL_INTERVAL_MS = 60_000;

export function useMaintenanceMode() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const checkMaintenanceMode = useCallback(async () => {
    const config = await fetchMaintenanceConfig();
    setIsMaintenanceMode(config.enabled);
    setIsLoading(false);
    return config.enabled;
  }, []);

  useEffect(() => {
    void checkMaintenanceMode();
  }, [checkMaintenanceMode]);

  useEffect(() => {
    if (!isMaintenanceMode) {
      return;
    }

    const intervalId = globalThis.setInterval(() => {
      void checkMaintenanceMode();
    }, MAINTENANCE_POLL_INTERVAL_MS);

    return () => {
      globalThis.clearInterval(intervalId);
    };
  }, [checkMaintenanceMode, isMaintenanceMode]);

  return { isMaintenanceMode, isLoading };
}
